

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.ChMftaUT.js","_app/immutable/chunks/NZTpNUN0.js","_app/immutable/chunks/p3uxj6nt.js","_app/immutable/chunks/DNEeYo6t.js","_app/immutable/chunks/DYsRO5qq.js","_app/immutable/chunks/COJhjt8E.js","_app/immutable/chunks/DtmmT001.js","_app/immutable/chunks/VJoPrkHq.js","_app/immutable/chunks/C_AwegD5.js","_app/immutable/chunks/Dg6_4QY_.js"];
export const stylesheets = [];
export const fonts = [];
